<h3>Férias Especiais Administrativas</h3>
<a href="#" class="sr-only">Férias Especiais Administrativas</a>

<app-cabecalho-funcional [exercicioSelecionado]="exercicioSelecionado" [exibirPeriodoProgramacaoDisponivel]="false" [exibirTipoPeriodoAquisitivo]="true"></app-cabecalho-funcional>

<form [formGroup]="formulario" (ngSubmit)="concluir()" novalidate>
    <div class="row">
        <div class="col-12 col-lg-6 mt-2">
            <div class="br-input" [class.danger]="campoInvalido('numeroProcesso')">
                <label for="numero-processo">Número do processo administrativo (Obrigatório)</label>
                <input id="numero-processo" pInputText formControlName="numeroProcesso" mask="00000.000000/0000-00" [dropSpecialCharacters]="false" placeholder="99999.999999/9999-99" maxlength="20" (input)="registrarAlteracao()" />
                <p class="feedback danger" role="alert" *ngIf="campoInvalido('numeroProcesso') && !campoObrigatorioNaoInformado('numeroProcesso')">Informe o processo no formato 99999.999999/9999-99.</p>
                <p class="mt-1" *ngIf="campoObrigatorioNaoInformado('numeroProcesso')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>
        <div class="col-12 col-lg-2 mt-2">
            <div #dsgovInput class="br-input" [class.danger]="campoInvalido('quantidadeDias')">
                <label for="quantidade-dias-administrativas">Quantidade de Dias (Obrigatório)</label>
                <input id="quantidade-dias-administrativas" type="number" min="1" max="45" step="1" formControlName="quantidadeDias" (input)="validarInputQuantidadeDias($event)" />
                <p class="feedback danger" role="alert" *ngIf="campoInvalido('quantidadeDias') && !campoObrigatorioNaoInformado('quantidadeDias')">Informe uma quantidade inteira entre 1 e 45 dias.</p>
                <p class="mt-1" *ngIf="campoObrigatorioNaoInformado('quantidadeDias')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12 mt-2">
            <div class="br-textarea" [class.danger]="campoInvalido('justificativa')">
                <label for="justificativa">Justificativa das férias especiais (Obrigatório)</label>
                <textarea id="justificativa" pInputTextarea formControlName="justificativa" rows="6" maxlength="300" (input)="registrarAlteracao()"></textarea>
                <span class="limit" aria-live="polite">
                    <b>{{ formulario.controls.justificativa.value?.length ?? 0 }}</b>
                    de
                    <b>300</b>
                    caracteres digitados
                </span>
                <p class="feedback danger" role="alert" *ngIf="campoInvalido('justificativa') && !campoObrigatorioNaoInformado('justificativa')">A justificativa deve conter entre 10 e 300 caracteres.</p>
                <p class="mt-1" *ngIf="campoObrigatorioNaoInformado('justificativa')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col text-right">
            <button type="button" class="secondary mr-2 botao-responsivo" pButton (click)="confirmarVoltar()">Voltar</button>
            <button type="submit" class="primary botao-responsivo" pButton>Concluir</button>
        </div>
    </div>
</form>

<p-confirmDialog key="confirmPadrao" acceptLabel="Sim" rejectLabel="Não"></p-confirmDialog>
